module.exports = __webpack_public_path__ + "img/user.9f94447.svg";